<template>
  <!-- 备注： 已转移到短信列表模块 此页面暂时无用！-->
  <div>
    <PageHead title="创建短信人员主送组"></PageHead>
    <div class="oa-layout-content">
      <div class="search-flex">
        <div class="search-flex-item mr20">
          <span>主送至部门组：</span>
          <a-input
            class="w300"
            placeholder="请输入主送至部门组"
            v-model="queryForm.groupName"
          />
        </div>
        <div class="search-flex-item">
          <a-button type="primary" @click="subMit" :loading="loading">
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel">
            取消
          </a-button>
        </div>
      </div>
      <div class="mt20 mb20">
        <a-button type="primary" @click="add()" icon="plus"> 新建</a-button>
      </div>
      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="SMSGroupList"
        rowKey="id"
        :loading="loading"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ index + 1 + (page - 1) * 10 }}
        </span>
        <div slot="action" slot-scope="text, record">
          <a-button type="link" class="btn-link" @click="add(record)">
            编辑
          </a-button>
          <a-divider type="vertical" />
          <a-button
            type="link"
            class="btn-link"
            @click="showDeleteConfirm(record.id)"
          >
            删除
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination v-model="page" :total="total" @change="pageChange" />
      </div>
    </div>
    <appfloor></appfloor>
    <a-modal v-model="visible" title="主送配置" @ok="handleOk" :width="800">
      <div class="role-formCont">
        <span class="w100 rightAlgin">主送至部门组:</span>
        <a-input
          class="w300 ml20"
          placeholder="请输入主送至部门组"
          v-model="addForm.groupName"
        />
      </div>
      <blank height="20"> </blank>
      <div class="role-formCont">
        <span class="w100 rightAlgin">主送说明:</span>
        <a-textarea
          class="w300 ml20"
          placeholder="请输入主送说明"
          v-model="addForm.groupExplain"
          :rows="2"
        />
      </div>
      <blank height="20"> </blank>
      <div class="role-scrollY">
        <div
          class="queryUser-content"
          style="
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
          "
        >
          <!-- 左侧组织机构 -->
          <div
            class="treeList-cont"
            style="
              width: 300px;
              padding-right: 20px;
              border-right: 1px solid #f5f5f5;
            "
          >
            <a-tree
              v-model="addForm.orgIds"
              v-if="treeData.length > 0"
              :tree-data="treeData"
              @select="onSelect"
              :replaceFields="replaceFields"
              :default-expanded-keys="expandedKeys"
            >
            </a-tree>
          </div>
          <!-- 右侧表格信息 -->
          <div class="table-cont" style="width: 400px; padding-right: 20px">
            <a-table
              :pagination="false"
              :columns="columnsUser"
              :data-source="dataUser"
              :row-selection="{
                onChange: onChange,
                onSelect: onSelect,
                onSelectAll: onSelectAll
              }"
              :rowKey="
                (record, index) => {
                  return record.id
                }
              "
            >
            </a-table>
            <div
              class="userPage"
              style="
                margin-top: 20px;
                display: flex;
                justify-content: flex-end;
                align-items: center;
              "
            >
              <a-pagination
                v-model="userPage"
                :total="userTotal"
                @change="userPageChange"
              />
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
// 弹窗人员表格列
const columnsUser = [
  {
    title: '姓名',
    dataIndex: 'fullName',
    key: 'fullName',
    width: 80,
    align: 'center'
  },
  {
    title: '手机号',
    dataIndex: 'phoneNumber',
    key: 'phoneNumber',
    width: 80,
    align: 'center'
  }
]
// 短信主送组表格列
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    width: 80,
    align: 'center',
    scopedSlots: { customRender: 'index' }
  },
  {
    title: '主送至部门组',
    dataIndex: 'groupName',
    key: 'groupName',
    ellipsis: true,
    align: 'left'
  },
  {
    title: '主送说明',
    dataIndex: 'groupExplain',
    key: 'groupExplain',
    ellipsis: true,
    align: 'left'
  },

  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'left',
    width: 160
  }
]
import {
  getSMSGroupList,
  addSMSGroup,
  updateSMSGroup,
  delSMSGroup,
  getOrgIds,
  // getGroupDetial,
  getTreeList,
  getUser
} from './api/api'
export default {
  data() {
    return {
      visible: false,
      queryForm: {}, // 检索条件
      addForm: {
        groupName: '',
        groupExplain: '',
        orgIds: []
      },
      // 短信表格分页
      page: 1,
      size: 10,
      total: 0, //总条数

      SMSGroupList: [], // 短信主送组列表
      orgIds: [], // 菜单列表
      treeData: [], // 组织机构菜单列表
      expandedKeys: [10010], //当前默认选中的机构 ，为了保证默认展开
      checkAll: false,
      columns,
      loading: false,
      replaceFields: {
        children: 'treeList',
        title: 'organizationName',
        key: 'id'
      },
      selectedKeys: 0,
      // 弹窗的用户信息
      userPage: 1,
      userSize: 5,
      userTotal: 0,
      userIds: [],
      userRowKeys: [],
      columnsUser, // 弹窗人员表格列
      dataUser: [] // 弹窗用户表格信息
    }
  },
  computed: {
    allorgIds: function () {
      // `this` 指向 vm 实例
      // 全选
      let Header = []
      for (const value of this.orgIds) {
        Header.push(value.organizationId)
      }
      return Header
    }
  },
  created() {
    this.load()
    getTreeList().then((res) => {
      this.treeData = res.data.data
    })
    getOrgIds().then((res) => {
      //获取菜单列表
      if (res.data.code == 0) {
        this.orgIds = res.data.data
      }
    })
  },
  methods: {
    // 只需监测发生变化 即可
    onChange(selectedRowKeys, selectedRows) {
      this.userRowKeys = selectedRowKeys
      this.userIds = selectedRows.map((item) => {
        return item.id
      })
    },
    onSelect(record, selected, selectedRows) {
      // this.userIds = selectedRows.map((item) => {
      //   return item.id
      // })
    },
    onSelectAll(selected, selectedRows, changeRows) {
      // this.userIds = selectedRows.map((item) => {
      //   return item.id
      // })
    },
    load() {
      this.loading = true
      let params = this.queryForm
      params.page = this.page
      params.size = this.size
      getSMSGroupList(params).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.SMSGroupList = res.data.data
          this.total = res.data.count
        }
      })
    },
    // 确定删除
    showDeleteConfirm(id) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          delSMSGroup({ id }).then((res) => {
            if (res.data.code == 0) {
              this.$message.success('删除成功')
              this.load()
            }
          })
        }
      })
    },
    // 确认修改/添加
    handleOk() {
      this.addForm.userIds = this.userIds
      if (this.addForm.id) {
        updateSMSGroup(this.addForm).then((res) => {
          if (res.data.code == 0) {
            this.$message.success('操作成功')
            this.load()
            this.visible = false
          }
        })
      } else {
        addSMSGroup(this.addForm).then((res) => {
          if (res.data.code == 0) {
            this.$message.success('添加成功')
            this.load()
            this.visible = false
          }
        })
      }
    },

    // 打开弹窗
    add(addForm) {
      // 清空数据
      this.dataUser = []
      this.userIds = []
      this.userRowKeys = []
      if (addForm) {
        // 修改
        this.addForm = addForm
        // this.orgIdsonChange()
      } else {
        this.addForm = { groupName: '', groupExplain: '', orgIds: [] }
      }
      this.visible = true
    },
    onCheckAllChange(e) {
      if (e.target.checked) {
        // 全选
        this.addForm.orgIds = this.allorgIds
      } else {
        this.addForm.orgIds = []
      }
    },

    orgIdsonChange() {
      //判断是否全选
      if (this.addForm.orgIds.length == this.allorgIds.length) {
        //全部选择
        this.checkAll = true
      } else {
        this.checkAll = false
      }
    },
    // 短信主送组 分页
    pageChange(pageNumber) {
      this.page = pageNumber
      this.load()
    },
    //取消
    cancel() {
      this.queryForm = {}
    },
    //搜索
    subMit() {
      this.page = 1
      this.load()
    },
    // 获取用户 弹窗用户表格信息
    getUserList() {
      let data = {}
      data.page = this.userPage
      data.size = this.userSize
      data.organizationId = this.selectedKeys
      getUser(data).then((res) => {
        if (res.data.code === 0) {
          this.dataUser = res.data.data
          this.userTotal = res.data.count
        }
      })
    },
    // 点击左侧组织机构 查询用户
    onSelect(selectedKeys) {
      if (selectedKeys.length > 0) {
        this.selectedKeys = selectedKeys[0]
        this.getUserList()
      }
    },
    // 弹窗用户 分页
    userPageChange(pageNumber) {
      this.userPage = pageNumber
      this.getUserList()
    }
  }
}
</script>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}

.statusDiv {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.role-scrollY {
  overflow-y: scroll;
  max-height: calc(100vh - 500px);
}

.role-formCont {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 10px;
  .role-formlabel {
    width: 120px;
    text-align: right;
    margin-right: 20px;
  }
  .role-formvalue {
    width: calc(100% - 120px);
  }
  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0;
    margin-bottom: 10px;
  }
  // 弹窗底部 组织机构与表格
  .queryUser-content {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    .treeList-cont {
      width: 200px;
      padding-right: 20px;
      border-right: 1px solid #000;
    }
    .table-cont {
      width: 400px;
      .userPage {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/system/smsPerson.vue